const d3 = Object.assign(
  {},
  require('d3-selection'),
  require('d3-scale'),
  require('d3-axis'),
  require('d3-array'),
  require('d3-transition'),
  require('d3-format')
)
import tippy from 'tippy.js'
import { hideAll } from 'tippy.js'

import './scss/main.scss'

import data from './data/data.json'

//make city names from data match mapbox label names
const cities = data
  .map((d) => d.city)
  .map((s) => s.replace('Osaka', 'Ōsaka'))
  .map((s) => s.replace('Bangalore', 'Bengaluru'))
  .map((s) => s.replace('Washington, D.C.', 'Washington'))
  .map((s) => s.replace('Sao Paulo', 'São Paulo'))
  .map((s) => s.replace('Ho Chi Minh', 'Ho Chi Minh City'))
  .map((s) => s.replace("Xi'an", 'Xi’an'))

let isMobile = window.innerWidth < 500 ? true : false
let mq = window.matchMedia('(max-width: 48em)')

tippy.setDefaultProps({
  allowHTML: true,
  trigger: 'mouseenter focus',
  animation: 'fade',
  hideOnClick: true,
  interactive: false,
  maxWidth: 250,
  theme: 'cpp',
  onMount(tip) {
    let close = document.querySelector('.tooltip-close')

    if (!close) return
    close.addEventListener('click', () => {
      tip.hide()
    })
  },
})

const tooltip = document.getElementById('tooltip')
const dek = document.querySelector('.interactive__dek')
let tooltipInstance

let map
let canvas
let svg
let rect
let width
let height

const maxRad = 25
const minRad = 10
const margin = { top: 30, left: 30 }
let columns

function setupMapbox() {
  mapboxgl.accessToken =
    'pk.eyJ1Ijoid2NoYXNlMTQiLCJhIjoiY2p2dnYwOXBvMGJvNDQzcDkxcTZqNWd3dCJ9.UqxE9xtZJevAQem-lKCYnA'
  map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/wchase14/ckhmkp7ef06ty19nrfdtj37e8',
    fitBounds: [
      [-163.125, 70.02058730174062],
      [172.265625, -55.17886766328199],
    ],
    zoom: 1.1,
  })

  map.scrollZoom.disable()

  map.on('load', () => {
    //filter city names to only those in the data
    map.setFilter('place-city-label-major', [
      'all',
      ['<', ['get', 'symbolrank'], 9],
      ['==', ['get', 'type'], 'city'],
      [
        'in',
        ['coalesce', ['get', 'name_en'], ['get', 'name']],
        ['literal', cities],
      ],
    ])

    map.addControl(new mapboxgl.NavigationControl())
  })

  dek.innerHTML = `This interactive map visualizes the top 125 cities in <a href="https://www.kearney.com/global-cities/2020">Kearney’s 2020 Global Cities Index</a>. A <b class="blue">blue</b> circle indicates the city’s ranking has improved compared to 2015. <b class="red">Red</b> signifies a decline and <b class="grey">grey</b> denotes no change. The size of each circle corresponds to the city’s population. Hover over a circle to view detailed information. Toggle between viewing the data in a map or a list. 
`

  canvas = map.getCanvasContainer()
  svg = d3
    .select(canvas)
    .append('svg')
    .attr('id', 'my_svg')
    .attr('class', 'svg-map-position')
  rect = document.querySelector('#my_svg').getBoundingClientRect()
  width = rect.width
  height = rect.height
  columns = Math.floor(width / (maxRad * 2 + margin.left))
}

function setupMobile() {
  dek.innerHTML = `This interactive visualizes the top 125 cities in <a href="https://www.kearney.com/global-cities/2020">Kearney’s 2020 Global Cities Index</a>. A <b class="blue">blue</b> circle indicates the city’s ranking has improved compared to 2015. <b class="red">Red</b> signifies a decline and <b class="gray">grey</b> denotes no change. The size of each circle corresponds to the city’s population. To view our full interactive map of this data, please use a desktop computer.`

  width = document.querySelector('#interactive__charts').getBoundingClientRect()
    .width

  columns = Math.floor(width / (maxRad * 2 + margin.left))
  const rows = Math.ceil(125 / columns)
  height = rows * (maxRad * 2 + margin.top)

  document.querySelector('.interactive__filters').remove()
  document.querySelector('#map').remove()

  svg = d3
    .select('#interactive__charts')
    .style('max-height', '400px')
    .style('overflow-y', 'scroll')
    .append('svg')
    .attr('id', 'my_svg')
    .attr('height', height)
}

isMobile ? setupMobile() : setupMapbox()

function init() {
  resize(mq)

  drawChart()
  hideLoading()
  !isMobile ? update() : ''
}

/**
 *
 * Calls the Chart function to draw the chart with the current dataset.
 *
 */

function drawChart() {
  let aScale = d3
    .scaleSqrt()
    .domain([
      0,
      d3.max(
        data
          .map((d) => d.data)
          .flat()
          .map((d) => d.population)
      ),
    ])
    .range([minRad, maxRad])

  let zoomScale = d3.scaleLinear().domain([1.2, 3]).range([0.2, 1])

  let defs = svg.append('defs')

  let blueGrad = defs.append('radialGradient').attr('id', 'blueGradient')
  blueGrad
    .append('stop')
    .attr('offset', '0%')
    .attr('style', 'stop-color:#EBF1F8;')
  blueGrad
    .append('stop')
    .attr('offset', '95%')
    .attr('style', 'stop-color:#3b75BB;')

  let redGrad = defs.append('radialGradient').attr('id', 'redGradient')
  redGrad
    .append('stop')
    .attr('offset', '0%')
    .attr('style', 'stop-color:#FEF3E6;')
  redGrad
    .append('stop')
    .attr('offset', '95%')
    .attr('style', 'stop-color:#ED392A;')

  let greyGrad = defs.append('radialGradient').attr('id', 'greyGradient')
  greyGrad
    .append('stop')
    .attr('offset', '0%')
    .attr('style', 'stop-color:#EBEBEB;')
  greyGrad
    .append('stop')
    .attr('offset', '95%')
    .attr('style', 'stop-color:#404040;')

  let circleGroups = svg
    .selectAll('.city-group')
    .data(data, (d) => d.city)
    .join('g')
    .attr('class', 'city-group')
    .on('mouseover', interactions.mouseover)
    .on('mouseleave', interactions.mouseleave)

  circleGroups
    .append('circle')
    .attr('cx', 0)
    .attr('cy', 0)
    .attr('r', (d) => aScale(d.population))
    .attr('fill', (d) => {
      if (d.rank_change === 0) return 'url(#greyGradient)'
      if (d.rank_change > 0) return 'url(#blueGradient)'
      if (d.rank_change < 0) return 'url(#redGradient)'
    })
    .attr('opacity', 0.6)

  let rankLabels = circleGroups
    .append('text')
    .text((d) => d.rank_2020)
    .attr('font-family', 'Roboto')
    .attr('fill', 'black')
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')

  let cityLabels = circleGroups
    .append('text')
    .text((d) => `${d.city}`)
    .attr('class', 'label__city')
    .attr('text-anchor', 'middle')
    .attr('transform', `translate(0, ${-maxRad - 12})`)

  let countryLabels = circleGroups
    .append('text')
    .text((d) => `${d.country}`)
    .attr('class', 'label__country')
    .attr('text-anchor', 'middle')
    .attr('transform', `translate(0, ${-maxRad - 1})`)

  if (isMobile) {
    circleGroups
      .transition()
      .duration(750)
      .attr(
        'transform',
        (d, i) =>
          `translate(${
            (i % columns) * (maxRad * 2 + margin.left) + margin.left + maxRad
          },${
            Math.floor(i / columns) * (maxRad * 2 + margin.top) +
            maxRad +
            margin.top
          })`
      )
    rankLabels.attr('opacity', 1)
  } else {
    cityLabels.attr('opacity', 0).style('visibility', 'hidden')
    countryLabels.attr('opacity', 0).style('visibility', 'hidden')
    rankLabels.attr('opacity', zoomScale(map.getZoom()))
  }

  if (!isMobile) {
    const mapButton = document.querySelector('.input__button-map')
    const rankButton = document.querySelector('.input__button-rank')
    const resetButton = document.querySelector('#reset')

    function toRank() {
      mapButton.classList.remove('is-selected')
      rankButton.classList.add('is-selected')
      resetButton.classList.add('filter-hidden')

      hideMap()

      circleGroups
        .transition()
        .duration(750)
        .attr(
          'transform',
          (d, i) =>
            `translate(${
              (i % columns) * (maxRad * 2 + margin.left) + margin.left + maxRad
            },${
              Math.floor(i / columns) * (maxRad * 2 + margin.top) +
              maxRad +
              margin.top
            })`
        )

      cityLabels
        .transition()
        .duration(750)
        .attr('opacity', 1)
        .style('visibility', 'visible')
      countryLabels
        .transition()
        .duration(750)
        .attr('opacity', 1)
        .style('visibility', 'visible')
      rankLabels.attr('opacity', 1)
    }

    function toMap() {
      mapButton.classList.add('is-selected')
      rankButton.classList.remove('is-selected')
      resetButton.classList.remove('filter-hidden')

      showMap()

      circleGroups
        .transition()
        .duration(750)
        .attr('transform', function (d) {
          let group_x = project(d.data[0].geometry).x
          let group_y = project(d.data[0].geometry).y
          return `translate(${group_x}, ${group_y})`
        })

      cityLabels.transition().duration(750).attr('opacity', 0)
      countryLabels.transition().duration(750).attr('opacity', 0)
      zoomOpacity()
    }

    function zoomOpacity() {
      let zoom = map.getZoom()
      rankLabels.attr('opacity', zoomScale(zoom))
    }

    mapButton.addEventListener('click', toMap)
    rankButton.addEventListener('click', toRank)
    resetButton.addEventListener('click', resetMap)

    map.on('viewreset', update)
    map.on('move', update)
    map.on('moveend', update)

    map.on('zoomend', zoomOpacity)
  }
}

const interactions = {
  mouseover(event, d) {
    if (this._tippy) {
      this._tippy.setContent(interactions.setTooltipContent(d))
      return
    }
    tooltipInstance = tippy(this, {
      content: interactions.setTooltipContent(d),
    })
  },
  mouseleave(event, d) {
    hideAll({ duration: 0 })
  },
  setTooltipContent(d) {
    const container = document.createElement('div')

    function tooltipFormat(data, value) {
      let content = data

      const absoluteFormat = d3.format('.2s')
      if (value === 'population') {
        content = absoluteFormat(data)
      }

      return content
    }

    const values = ['city', 'country', 'population', 'rank_2020', 'rank_2015']
    for (const value of values) {
      let dataRow = d.data[0]
      let content = tooltipFormat(d[value], value)
      tooltip.content.querySelector(
        `[data-value="${value}"]`
      ).innerHTML = content
    }
    const node = document.importNode(tooltip.content, true)
    container.appendChild(node)
    return container.innerHTML
  },
}

/**
 *
 * Hides all elements hidden on initial load
 *
 */

function hideLoading() {
  document.querySelector('.loading-container').style.display = 'none'
  document
    .querySelectorAll('.hide-on-load')
    .forEach((el) => el.classList.remove('hide-on-load'))
}

/**
 *
 * If we switch between mobile & desktop, update isMobile. Optionally, redraw the chart.
 *
 */

function resize(mediaQueryList) {
  if (mediaQueryList.matches) {
    isMobile = true
  } else {
    isMobile = false
  }
}

//functions for mapbox d3 connection
function project(d) {
  return map.project(new mapboxgl.LngLat(+d[0], +d[1]))
}

function update() {
  svg.selectAll('.city-group').attr('transform', function (d) {
    let group_x = project(d.data[0].geometry).x
    let group_y = project(d.data[0].geometry).y
    return `translate(${group_x}, ${group_y})`
  })
}

function setMapOpacity(value) {
  d3.selectAll('.mapboxgl-canvas')
    .transition()
    .duration(500)
    .style('opacity', value)
  d3.selectAll('.mapboxgl-control-container')
    .transition()
    .duration(500)
    .style('opacity', value)
}

function resetMap() {
  map.setZoom(1.1)
  map.fitBounds([
    [-163.125, 70.02058730174062],
    [172.265625, -55.17886766328199],
  ])
}

function showMap() {
  setMapOpacity(1)
  map.boxZoom.enable()
  map.scrollZoom.enable()
  map.dragPan.enable()
  map.dragRotate.enable()
  map.keyboard.enable()
  map.doubleClickZoom.enable()
  map.touchZoomRotate.enable()

  map.on('viewreset', update)
  map.on('move', update)
  map.on('moveend', update)
}

function hideMap() {
  setMapOpacity(0.1)
  map.boxZoom.disable()
  map.scrollZoom.disable()
  map.dragPan.disable()
  map.dragRotate.disable()
  map.keyboard.disable()
  map.doubleClickZoom.disable()
  map.touchZoomRotate.disable()

  map.off('viewreset', update)
  map.off('move', update)
  map.off('moveend', update)
}

/**
 *
 * Watch for changes on window resize
 * Taken from: https://stackoverflow.com/questions/56466261/matchmedia-addlistener-marked-as-deprecated-addeventlistener-equivalent
 * Includes fallback for Safari, required as of September 2019
 *
 */

try {
  mq.addEventListener('change', (e) => {
    resize()
  })
} catch (error1) {
  try {
    mq.addEventListener((e) => {
      resize()
    })
  } catch (error2) {
    console.log(error2)
  }
}

window.addEventListener('DOMContentLoaded', init)

//graveyard

// let grain = defs.append('filter').attr('id', 'grain');

// grain
//   .append('feTurbulence')
//   .attr('type', 'turbulence')
//   .attr('numOctaves', '3')
//   .attr('baseFrequency', '1')
//   .attr('result', 'turb');

// grain
//   .append('feComposite')
//   .attr('in', 'turb')
//   .attr('operator', 'arithmetic')
//   .attr('k1', '0')
//   .attr('k2', '0.65')
//   .attr('k3', '0.2')
//   .attr('result', 'turbComposite');

// grain
//   .append('feComposite')
//   .attr('operator', 'in')
//   .attr('in', 'turbComposite')
//   .attr('in2', 'SourceGraphic')
//   .attr('result', 'finalComposite');

// grain
//   .append('feBlend')
//   .attr('mode', 'screen')
//   .attr('in', 'finalComposite')
//   .attr('in2', 'SourceGraphic');

// function wrap(text, wrapWidth, yAxisAdjustment = 0) {
//   text.each(function () {
//     var text = d3.select(this),
//       words = text.text().split(/\s+/).reverse(),
//       word,
//       line = [],
//       lineNumber = 0,
//       lineHeight = 1.1, // ems
//       y = text.attr('y'),
//       dy = parseFloat(text.attr('dy')) - yAxisAdjustment,
//       tspan = text
//         .text(null)
//         .append('tspan')
//         .attr('x', 0)
//         .attr('y', y)
//         .attr('dy', `${dy}em`);
//     while ((word = words.pop())) {
//       line.push(word);
//       tspan.text(line.join(' '));
//       if (tspan.node().getComputedTextLength() > wrapWidth) {
//         line.pop();
//         tspan.text(line.join(' '));
//         line = [word];
//         tspan = text
//           .append('tspan')
//           .attr('x', 0)
//           .attr('y', y)
//           .attr('dy', ++lineNumber * lineHeight + dy + 'em')
//           .text(word);
//       }
//     }
//   });
//   return 0;
// }
